import React from 'react';
import { Divider, Grid, CardContent } from '@mui/material';
import { styleCardContent } from './style';

export default function CardUser({ children }) {
  return (
    <div>
      <Divider />
      <CardContent style={styleCardContent}>
        <Grid container spacing={0} alignItems="center">
          <Grid item xs={6} style={{ textAlign: 'left' }}>
            {children[0]}
          </Grid>
          <Grid item xs={6} style={{ textAlign: 'right' }}>
            {children[1]}
          </Grid>
        </Grid>
      </CardContent>
    </div>
  );
}
